import { useTheme } from '@mui/material/styles'
import * as React from 'react'
import { useCallback, useState } from 'react'

import QueryStatsOutlinedIcon from '@mui/icons-material/QueryStatsOutlined'
import { SalesFunnelDialog } from '@user/components/SalesFunnel/SalesFunnelDialog/SalesFunnelDialog'
import Typography from '@mui/material/Typography'
import {
  navIconSize,
  NavItem,
  navItemTextStyle,
  navItemTileStyle,
} from './NavItem'
import { NavTooltip } from './NavTooltip'

export const SalesFunnelMenuOption = ({
  batchContent,
  expanded,
}: {
  batchContent: number
  expanded: boolean
}) => {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false)

  const openDialog = useCallback(() => setDialogOpen(true), [])
  const closeDialog = useCallback(() => setDialogOpen(false), [])

  const theme = useTheme()

  return (
    <>
      <NavTooltip label="Sales Funnels" expanded={expanded}>
        <NavItem
          onClick={openDialog}
          data-test-id="salesFunnelIcon"
          style={{
            ...navItemTileStyle,
            flexGrow: 0,
            padding: theme.spacing(0),
            marginBottom: batchContent && '20px',
          }}
        >
          <QueryStatsOutlinedIcon
            sx={{
              margin: '0px 8px 0px 5px',
              height: navIconSize,
              width: navIconSize,
              flexShrink: 0,
            }}
          />
          <Typography sx={navItemTextStyle}>Sales Funnels</Typography>
        </NavItem>
      </NavTooltip>
      <SalesFunnelDialog open={dialogOpen} onClose={closeDialog} />
    </>
  )
}
